import { APPLICATION_KEYS } from '@repo/contracts';

/**
 * Applications the front door never sends anyone to: the platform itself (a person
 * sent here by their own role would loop), Org Admin, and roles outside the catalogue.
 * Training is open to everyone signed in, so it is a destination only by the person's
 * choice of default, and is left out of the priority pick separately.
 */
export const NEVER_A_DESTINATION: readonly string[] = [
  APPLICATION_KEYS.platform,
  APPLICATION_KEYS.retiring,
  APPLICATION_KEYS.other,
];
